export const typesStoredcarddet = {
    GET_STOREDCARDDET_SUCCESS:'GET_STOREDCARDDET_SUCCESS',
    GET_STOREDCARDDET_ERROR:'GET_STOREDCARDDET_ERROR',
    GET_STOREDCARDDET_BEGIN:'GET_STOREDCARDDET_BEGIN',
    GET_SAVESTOREDCARD_SUCCESS:'GET_SAVESTOREDCARD_SUCCESS',
    GET_SAVESTOREDCARD_ERROR:'GET_SAVESTOREDCARD_ERROR',
    RESET_STOREDCARD_INIT:'RESET_STOREDCARD_INIT',
    GET_SAVESTOREDCARD_BEGIN:'GET_SAVESTOREDCARD_BEGIN'


}
